import React from "react";
import { Label } from "reactstrap";
import Required from "./Required";
import { get } from "react-hook-form";

const MyInput = ({
  title,
  name,
  register,
  trigger,
  errors,
  setValue,
  placeholder,
  required,
  min,
  max,
  disabled,
}) => {
  const error = get(errors, name);

  const currencyPattern = /^[0-9]+(\.[0-9]{1,2})?$/;

  return (
    <div className="form-group my-2">
      <Label className="form-label" htmlFor={name}>
        {title}
        {required && title && <Required />}
      </Label>
      <div className="form-control-wrap">
        <input
          placeholder={placeholder}
          type="text"
          id={name}
          {...register(name, {
            required: required
              ? {
                  value: true,
                  message: `${title || name} is required`,
                }
              : false,
            pattern: {
              value: currencyPattern,
              message: "Please enter a valid number (e.g. 1.22, 15.25)",
            },
            validate: (value) => {
              const num = parseFloat(value);
              if (isNaN(num)) return "Invalid number";
              if (min !== undefined && num < min)
                return `Number must be at least ${min.toFixed(2)}`;
              if (max !== undefined && num > max)
                return `Number must not exceed ${max.toFixed(2)}`;
              return true;
            },
          })}
          className={`form-control ${error ? "is-invalid" : ""}`}
          onChange={(e) => {
            const cleaned = e.target.value.replace(/[^0-9.]/g, "");
            const parts = cleaned.split(".");
            if (parts.length > 2) return;
            if (parts[1]?.length > 2) return;
            setValue(name, cleaned, { shouldValidate: true });
          }}
          disabled={disabled}
        />
        {error && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {error.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default MyInput;
